import React, { Component } from 'react';
import Select from 'react-select';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { getGetRequestOptions } from "../../components/GetToken";
import ToastMsg from '../../components/ToastMsg';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import "./../../../style/table.css";
import { AppContext } from '../../context/AppContext';

const customStylesSelect = {
    control: (provided) => ({
        ...provided,
        height: 'calc(1.35em + 1.1rem + 2px)',
        minHeight: '35px'
    }),
    valueContainer: (provided) => ({
        ...provided,
    })
};

class SparePartsCostReport extends Component {

    static contextType = AppContext;
    state = {
        businessUnit: process.env.REACT_APP_EMD_BU_ID,
        receivingBusinessUnit: "",
        fromDate: "",
        toDate: "",
        reportData: [],
        allBusinessUnits: [],
        showReport: false,
        loading: false,
        showDetailsModal: false,
        selectedEquipment: null,
        equipmentDetails: [],
        detailsLoading: false,
        detailsPagination: {
            currentPage: 1,
            totalPages: 0,
            totalRecords: 0,
            limit: 20,
            hasNextPage: false,
            hasPrevPage: false
        },
        detailsSummary: {
            totalCost: 0,
            totalQuantity: 0,
            totalTransactions: 0
        },
        reportSummary: {
            totalCost: 0,
            totalEquipment: 0,
            totalTransactions: 0,
            totalCategories: 0
        },
        expandedCategories: {},
        errors: {
            fromDate: "",
            toDate: "",
        },
        touched: {
            fromDate: false,
            toDate: false
        }

    }

    componentDidMount() {
        const { allBusinessUnits, ...baseState } = this.state;
        this.baseState = baseState;
        this.getAllBu();
        
        // Add ESC key listener for modal
        document.addEventListener('keydown', this.handleEscKey);
    }

    componentWillUnmount() {
        // Remove ESC key listener
        document.removeEventListener('keydown', this.handleEscKey);
    }

    handleEscKey = (event) => {
        if (event.key === 'Escape' && this.state.showDetailsModal) {
            this.closeDetailsModal();
        }
    }

    handleInputOnChange = evt => {
        this.setState({ [evt.target.name]: evt.target.value });
    };


    handleBuChange = businessUnit => {
        this.setState({ receivingBusinessUnit: businessUnit });
    }

    handleProjectAccChange = projectAccountant => {
        this.setState({ projectAccountant: projectAccountant });
    }

    getAllBu() {
        fetch(process.env.REACT_APP_API_URL + "get_business_units",
            getGetRequestOptions())
            .then((resp) => {
                return resp.json()
            })
            .then((resp) => {
                const tempResp = resp.data.map(function (element) {
                    return { ...element, label: element.projectName, value: element.projectId, isdisabled: element.projectName === 'EMD' ? false : true }
                }).filter(row => row.projectId !== process.env.REACT_APP_EMD_BU_ID);
                const newTempResp = tempResp.concat([{
                    "projectId": "all",
                    "projectName": "All",
                    "companyId": "",
                    "label": "All",
                    "value": "all"
                }]);
                this.setState({ allBusinessUnits: newTempResp });
            })
            .catch((error) => {
                console.log(error, "catch the hoop")
            });
    }

    excelExport = () => {
        const { receivingBusinessUnit, fromDate, toDate } = this.state;
        
        if (!receivingBusinessUnit || !fromDate || !toDate) {
            toast.error(<ToastMsg toastMessage={["Please select all filters and generate the report first"]} heading="Export Error" />, {
                position: toast.POSITION.TOP_RIGHT
            });
            return;
        }

        const token = this.context.jwt;
        const buValue = receivingBusinessUnit.value || receivingBusinessUnit;
        const link = process.env.REACT_APP_API_URL.split("api/")[0] + 
                    `report/equipment_spare_parts_cost_excel_export?businessUnit=${buValue}&fromDate=${fromDate}&toDate=${toDate}&token=${token.token}`;
        window.open(link, '_blank');
    }

    getReportData() {
        this.setState({ loading: true });

        const { receivingBusinessUnit, fromDate, toDate } = this.state;

        const formData = {
            receivingBusinessUnit: receivingBusinessUnit.value || receivingBusinessUnit,
            fromDate: fromDate,
            toDate: toDate
        };

        const jwt = this.context.jwt.token;
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + jwt },
            body: JSON.stringify(formData)
        };
        fetch(process.env.REACT_APP_API_URL + "reports/equipment_spare_parts_cost", requestOptions)
            .then((resp) => {
                return resp.json()
            })
            .then((resp) => {
                this.setState({ loading: false });

                if (resp.success === true) {
                    this.setState({
                        reportData: resp.data,
                        reportSummary: resp.summary
                    });
                }
                else {
                    var errorsMessage = [];

                    if (resp.errorMessage !== undefined && typeof resp.errorMessage === 'object') {
                        var errorsObj = resp.errorMessage;
                        Object.keys(errorsObj).forEach(function (value) {
                            errorsObj[value].forEach(function (v) {
                                errorsMessage.push(v)
                            });
                        });
                    } else if (resp.errorMessage !== undefined && (typeof resp.errorMessage === 'string' || resp.errorMessage instanceof String)) {
                        errorsMessage.push(resp.errorMessage);
                    } else {
                        errorsMessage.push("Something went wrong");
                    }
                    
                    toast.error(<ToastMsg toastMessage={errorsMessage} heading={resp.heading} />, {
                        position: toast.POSITION.TOP_RIGHT
                    });
                }
            })
            .catch((error) => {
                this.setState({ loading: false });
                console.log(error, "catch the hoop")
            });
    }

    showEquipmentDetails = (equipment) => {
        this.setState({
            selectedEquipment: equipment,
            showDetailsModal: true,
            detailsPagination: { ...this.state.detailsPagination, currentPage: 1 }
        }, () => {
            this.getEquipmentDetails(1);
        });
    }

    closeDetailsModal = () => {
        this.setState({
            showDetailsModal: false,
            selectedEquipment: null,
            equipmentDetails: [],
            detailsPagination: {
                currentPage: 1,
                totalPages: 0,
                totalRecords: 0,
                limit: 20,
                hasNextPage: false,
                hasPrevPage: false
            }
        });
    }

    toggleCategoryExpansion = (categoryName) => {
        this.setState(prevState => ({
            expandedCategories: {
                ...prevState.expandedCategories,
                [categoryName]: !prevState.expandedCategories[categoryName]
            }
        }));
    }

    getEquipmentDetails = (page = 1) => {
        if (!this.state.selectedEquipment) return;

        this.setState({ detailsLoading: true });

        const { selectedEquipment, fromDate, toDate, detailsPagination, receivingBusinessUnit } = this.state;

        const formData = {
            equipmentId: selectedEquipment.equipmentId,
            receivingBusinessUnit: receivingBusinessUnit.value || receivingBusinessUnit,
            fromDate: fromDate,
            toDate: toDate,
            page: page,
            limit: detailsPagination.limit
        };

        const jwt = this.context.jwt.token;
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + jwt },
            body: JSON.stringify(formData)
        };

        fetch(process.env.REACT_APP_API_URL + "reports/equipment_spare_parts_details_modal", requestOptions)
            .then((resp) => {
                return resp.json()
            })
            .then((resp) => {
                this.setState({ detailsLoading: false });

                if (resp.success === true) {
                    this.setState({
                        equipmentDetails: resp.data.sparePartsDetails,
                        detailsSummary: resp.data.summary,
                        detailsPagination: resp.data.pagination
                    });
                } else {
                    var errorsMessage = [];

                    if (resp.errorMessage !== undefined && typeof resp.errorMessage === 'object') {
                        var errorsObj = resp.errorMessage;
                        Object.keys(errorsObj).forEach(function (value) {
                            errorsObj[value].forEach(function (v) {
                                errorsMessage.push(v)
                            });
                        });
                    } else if (resp.errorMessage !== undefined && (typeof resp.errorMessage === 'string' || resp.errorMessage instanceof String)) {
                        errorsMessage.push(resp.errorMessage);
                    } else {
                        errorsMessage.push("Something went wrong");
                    }
                    
                    toast.error(<ToastMsg toastMessage={errorsMessage} heading={resp.heading} />, {
                        position: toast.POSITION.TOP_RIGHT
                    });
                }
            })
            .catch((error) => {
                this.setState({ detailsLoading: false });
                console.log(error, "catch the hoop")
            });
    }

    handleDetailsPageChange = (page) => {
        this.getEquipmentDetails(page);
    }



    fetchData = (inputValue, callback) => {
        if (!inputValue) {
            //callback([]);
            var api = process.env.REACT_APP_API_URL + "get_employee";
        } else {
            api = process.env.REACT_APP_API_URL + "get_employee?q=" + inputValue;
        }

        setTimeout(() => {
            fetch(api, getGetRequestOptions())
                .then((resp) => {
                    return resp.json()
                })
                .then((resp) => {
                    const tempArray = resp.data.map(function (element) {
                        return { ...element, id: element.employeeId, label: `${element.employeeName} ${element.employeeCode}`, value: element.employeeId }
                    });

                    callback(tempArray);
                })
                .catch((error) => {
                    console.log(error, "catch the hoop")
                });
        });
    }


    handleSubmit = evt => {
        evt.preventDefault();
        this.setState({ showReport: true });
        this.getReportData();
    }

    render() {

        const { errors, touched } = this.state;
        const excelExportEndPoint = process.env.REACT_APP_API_URL.split("api/")[0] + 'report/emo_details_excel_export';
        const token = this.context.jwt;

        const skeletonLenArr = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15]
        return (

            <>
                <div className="card card-custom">
                    <div className="card-header">
                        <div className="card-title">
                            <h3 className="card-label"><p className="text-primary">Equipment Spare Parts Cost Report</p></h3>
                        </div>
                        <div className="card-toolbar">
                            {this.state.showReport && this.state.reportData.length > 0 && (
                                <button 
                                    className="btn btn-success btn-sm" 
                                    onClick={this.excelExport}
                                    title="Export to Excel"
                                >
                                    <i className="fa fa-file-excel"></i> Export to Excel
                                </button>
                            )}
                        </div>
                    </div>

                    <form onSubmit={this.handleSubmit}>
                        <div className="card-body">
                            <div className="ml-12">

                            <div className="form-group row">
                                    <label htmlFor="example-text-input" className="col-lg-2 col-form-label" style={{ "textAlign": "center" }}>Business Unit</label>
                                    <div className="col-lg-6">
                                        <Select
                                            value={this.state.receivingBusinessUnit}
                                            onChange={this.handleBuChange}
                                            options={this.state.allBusinessUnits}
                                            styles={customStylesSelect}
                                        />
                                    </div>
                                </div>

                                <div className="form-group row">
                                    <label htmlFor="fromDate" className="col-lg-2 col-form-label" style={{ "textAlign": "center" }}>From  Date</label>
                                    <div className="col-lg-6">
                                        <div className="row">
                                            <div className="col-lg-5">
                                                <input type="date" name="fromDate" id="fromDate" value={this.state.fromDate} onChange={this.handleInputOnChange} className={`form-control form-control-md ${touched.fromDate === true ? (errors.fromDate === "" ? 'is-valid' : 'is-invalid') : ''}`} />
                                            </div>
                                            <div className="col-lg-7">
                                                <div className="form-group row">
                                                    <label htmlFor="toDate" className="col-lg-3 col-form-label" style={{ "textAlign": "center" }}>To Date</label>
                                                    <div className="col-lg-9">
                                                        <input type="date" name="toDate" id="toDate" value={this.state.toDate} onChange={this.handleInputOnChange} className={`form-control form-control-md ${touched.toDate === true ? (errors.toDate === "" ? 'is-valid' : 'is-invalid') : ''}`} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                               

                                <div className="form-group row">
                                    <div className="col-lg-2">
                                    </div>
                                    <div className="col-lg-6">
                                        <button 
                                            type="submit" 
                                            className="btn btn-success mr-2"
                                            disabled={this.state.loading}
                                        >
                                            {this.state.loading ? (
                                                <>
                                                    <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                                                    Loading...
                                                </>
                                            ) : (
                                                'Show'
                                            )}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>

                    {/* Report Results */}
                    {this.state.showReport && (
                        <div className="card-body">
                            {this.state.loading ? (
                                <div className="text-center">
                                    <div className="spinner-border text-primary" role="status">
                                        <span className="sr-only">Loading...</span>
                                    </div>
                                    <p className="mt-2">Loading report data...</p>
                                </div>
                            ) : (
                                <>
                                    {/* Summary Cards */}
                                    <div className="row mb-4">
                                        <div className="col-md-3">
                                            <div className="card card-custom ">
                                                <div className="card-body text-center">
                                                    <h4>৳ {this.state.reportSummary.totalCost.toLocaleString()}</h4>
                                                    <p className="mb-0">Total Cost</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="card card-custom ">
                                                <div className="card-body text-center">
                                                    <h4>{this.state.reportSummary.totalEquipment}</h4>
                                                    <p className="mb-0">Equipment Count</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="card card-custom ">
                                                <div className="card-body text-center">
                                                    <h4>{this.state.reportSummary.totalTransactions}</h4>
                                                    <p className="mb-0">Total Transactions</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="card card-custom ">
                                                <div className="card-body text-center">
                                                    <h4>{this.state.reportSummary.totalCategories}</h4>
                                                    <p className="mb-0">Total Equipment Type</p>
                                                </div>
                                            </div>
                                        </div>
                                        
                                    </div>

                                    {/* Equipment List */}
                                    {this.state.reportData.length > 0 ? (
                                        <div className="table-responsive">
                                            <table className="table table-bordered table-hover">
                                                <thead className="thead-dark">
                                                    <tr>
                                                        <th>Equipment</th>
                                                        <th>Model</th>
                                                        <th>Capacity</th>
                                                        <th>Total Cost</th>
                                                        <th>Transactions</th>
                                                        <th>Actions</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {this.state.reportData.map((category, categoryIndex) => (
                                                        <React.Fragment key={category.categoryId}>
                                                            {/* Category Header Row */}
                                                            <tr className="table-info">
                                                                <td>
                                                                    <strong 
                                                                        style={{ cursor: 'pointer' }} 
                                                                        onClick={() => this.toggleCategoryExpansion(category.categoryName)}
                                                                    >
                                                                        <i className={`fa ${this.state.expandedCategories[category.categoryName] ? 'fa-minus' : 'fa-plus'}`}></i>
                                                                        &nbsp; {category.categoryName} ({category.equipmentCount} equipment)
                                                                    </strong>
                                                                </td>
                                                                <td>-</td>
                                                                <td>-</td>
                                                                <td><strong>৳ {category.totalCost.toLocaleString()}</strong></td>
                                                                <td><strong>{category.totalTransactions}</strong></td>
                                                                <td>-</td>
                                                            </tr>
                                                            
                                                            {/* Equipment Rows (shown when expanded) */}
                                                            {this.state.expandedCategories[category.categoryName] && category.equipment.map((equipment, equipmentIndex) => (
                                                                <tr key={equipment.equipmentId}>
                                                                    <td style={{ paddingLeft: '30px' }}>
                                                                        &nbsp;&nbsp;&nbsp;&nbsp; {equipment.equipmentName} ({equipment.equipmentCode})
                                                                    </td>
                                                                    <td>{equipment.model}</td>
                                                                    <td>{equipment.capacity}</td>
                                                                    <td>৳ {equipment.totalCost.toLocaleString()}</td>
                                                                    <td>{equipment.totalTransactions}</td>
                                                                    <td>
                                                                        {equipment.totalTransactions > 0 ? (
                                                                            <button
                                                                                className="btn btn-sm btn-outline-primary"
                                                                                onClick={() => this.showEquipmentDetails(equipment)}
                                                                            >
                                                                                View Details
                                                                            </button>
                                                                        ) : (
                                                                            <span className="text-muted">No Data</span>
                                                                        )}
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </React.Fragment>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    ) : (
                                        <div className="text-center py-5">
                                            <h5>No spare parts data found for the selected criteria</h5>
                                            <p className="text-muted">Try adjusting your date range or business unit selection</p>
                                        </div>
                                    )}
                                </>
                            )}
                        </div>
                    )}
                </div>

                {/* Details Modal */}
                {this.state.showDetailsModal && (
                    <div 
                        className="modal fade show" 
                        style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1050 }}
                        onClick={(e) => {
                            if (e.target === e.currentTarget) {
                                this.closeDetailsModal();
                            }
                        }}
                    >
                        <div className="modal-dialog modal-xl" style={{ maxWidth: '95%', margin: '1.75rem auto', maxHeight: 'calc(100vh - 3.5rem)', display: 'flex' }}>
                            <div className="modal-content" style={{ display: 'flex', flexDirection: 'column', maxHeight: '100%' }}>
                                <div className="modal-header" style={{ flexShrink: 0 }}>
                                    <div>
                                        <h5 className="modal-title mb-1">
                                            Spare Parts Details - {this.state.selectedEquipment?.equipmentName} ({this.state.selectedEquipment?.equipmentCode})
                                        </h5>
                                        <small className="text-muted">
                                            Date Range: {this.state.fromDate} to {this.state.toDate}
                                        </small>
                                    </div>
                                    <button 
                                        type="button" 
                                        className="btn-close" 
                                        aria-label="Close"
                                        onClick={this.closeDetailsModal}
                                        style={{ 
                                            background: 'none',
                                            border: 'none',
                                            fontSize: '1.5rem',
                                            cursor: 'pointer',
                                            padding: '0.25rem',
                                            marginLeft: 'auto'
                                        }}
                                    >
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body" style={{ flex: 1, overflowY: 'auto', minHeight: 0 }}>
                                    {this.state.detailsLoading ? (
                                        <div className="text-center py-5">
                                            <div className="spinner-border text-primary" role="status">
                                                <span className="sr-only">Loading...</span>
                                            </div>
                                            <p className="mt-2">Loading details...</p>
                                        </div>
                                    ) : (
                                        <>
                                            {/* Summary Info */}
                                            <div className="row mb-3">
                                                <div className="col-md-4">
                                                    <div className="card">
                                                        <div className="card-body text-center py-2">
                                                            <h6 className="mb-1">৳ {this.state.detailsSummary.totalCost.toLocaleString()}</h6>
                                                            <small className="mb-0">Total Cost</small>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className="card">
                                                        <div className="card-body text-center py-2">
                                                            <h6 className="mb-1">{this.state.detailsSummary.totalQuantity.toLocaleString()}</h6>
                                                            <small className="mb-0">Total Quantity</small>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className="card">
                                                        <div className="card-body text-center py-2">
                                                            <h6 className="mb-1">{this.state.detailsSummary.totalTransactions}</h6>
                                                            <small className="mb-0">Total Transactions</small>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Pagination Info */}
                                            {this.state.detailsPagination.totalRecords > 0 && (
                                                <div className="row mb-3">
                                                    <div className="col-12">
                                                        <small className="text-muted">
                                                            Showing {this.state.detailsPagination.startRecord} to {this.state.detailsPagination.endRecord} of {this.state.detailsPagination.totalRecords} entries
                                                        </small>
                                                    </div>
                                                </div>
                                            )}

                                            {/* Details Table */}
                                            {this.state.equipmentDetails.length > 0 ? (
                                                <div className="table-responsive">
                                                    <table className="table table-sm table-bordered table-hover">
                                                        <thead className="thead-light">
                                                            <tr>
                                                                <th>Serial</th>
                                                                <th>Issue No</th>
                                                                <th>Issue Date</th>
                                                                <th>Item Name</th>
                                                                <th>Item Code</th>
                                                                <th>Quantity</th>
                                                                <th>Unit Rate</th>
                                                                <th>Unit</th>
                                                                <th>Total Amount</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {this.state.equipmentDetails.map((detail, index) => (
                                                                <tr key={index}>
                                                                    <td>{((this.state.detailsPagination.currentPage - 1) * this.state.detailsPagination.limit) + index + 1}</td>
                                                                    <td>{detail.issueNo}</td>
                                                                    <td>{detail.issueDate}</td>
                                                                    <td>{detail.itemName}</td>
                                                                    <td>{detail.itemCode}</td>
                                                                    <td>{detail.quantity.toLocaleString()}</td>
                                                                    <td>৳ {detail.unitRate.toLocaleString()}</td>
                                                                    <td>{detail.unitName}</td>
                                                                    <td>৳ {detail.totalAmount.toLocaleString()}</td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            ) : (
                                                <div className="text-center py-5">
                                                    <h6>No spare parts details found for this equipment</h6>
                                                </div>
                                            )}

                                            {/* Pagination Controls */}
                                            {this.state.detailsPagination.totalPages > 1 && (
                                                <div className="row mt-3">
                                                    <div className="col-12">
                                                        <nav>
                                                            <ul className="pagination justify-content-center">
                                                                <li className={`page-item ${!this.state.detailsPagination.hasPrevPage ? 'disabled' : ''}`}>
                                                                    <button 
                                                                        className="page-link" 
                                                                        onClick={() => this.handleDetailsPageChange(1)}
                                                                        disabled={!this.state.detailsPagination.hasPrevPage}
                                                                    >
                                                                        First
                                                                    </button>
                                                                </li>
                                                                <li className={`page-item ${!this.state.detailsPagination.hasPrevPage ? 'disabled' : ''}`}>
                                                                    <button 
                                                                        className="page-link" 
                                                                        onClick={() => this.handleDetailsPageChange(this.state.detailsPagination.currentPage - 1)}
                                                                        disabled={!this.state.detailsPagination.hasPrevPage}
                                                                    >
                                                                        Previous
                                                                    </button>
                                                                </li>
                                                                <li className="page-item active">
                                                                    <span className="page-link">
                                                                        {this.state.detailsPagination.currentPage} of {this.state.detailsPagination.totalPages}
                                                                    </span>
                                                                </li>
                                                                <li className={`page-item ${!this.state.detailsPagination.hasNextPage ? 'disabled' : ''}`}>
                                                                    <button 
                                                                        className="page-link" 
                                                                        onClick={() => this.handleDetailsPageChange(this.state.detailsPagination.currentPage + 1)}
                                                                        disabled={!this.state.detailsPagination.hasNextPage}
                                                                    >
                                                                        Next
                                                                    </button>
                                                                </li>
                                                                <li className={`page-item ${!this.state.detailsPagination.hasNextPage ? 'disabled' : ''}`}>
                                                                    <button 
                                                                        className="page-link" 
                                                                        onClick={() => this.handleDetailsPageChange(this.state.detailsPagination.totalPages)}
                                                                        disabled={!this.state.detailsPagination.hasNextPage}
                                                                    >
                                                                        Last
                                                                    </button>
                                                                </li>
                                                            </ul>
                                                        </nav>
                                                    </div>
                                                </div>
                                            )}
                                        </>
                                    )}
                                </div>
                                <div className="modal-footer" style={{ flexShrink: 0 }}>
                                    <button type="button" className="btn btn-secondary" onClick={this.closeDetailsModal}>
                                        Close
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                <ToastContainer />
            </>

        );
    }
}

export default SparePartsCostReport;